import { TIMESHIFTING_AUTO_DURATION } from '../../../core/timeshifting/types';
import { asPercent } from '../../../utils';

export const computeEPGSegmentsWidths = (markers) => [
  ...markers
    .reduce(
      (final, marker, i, arr) => (i === 0
        ? [asPercent(marker, TIMESHIFTING_AUTO_DURATION)]
        : [...final, asPercent(marker - arr[i - 1], TIMESHIFTING_AUTO_DURATION)]),
      []
    ),
  asPercent(TIMESHIFTING_AUTO_DURATION - markers[markers.length - 1], TIMESHIFTING_AUTO_DURATION)
].reverse();

export const formatMarkers = (programMarkers) => {
  if (!programMarkers?.length) return [];
  let markers = [];

  if (programMarkers.length === 1 && programMarkers[0] >= TIMESHIFTING_AUTO_DURATION) {
    markers = [...programMarkers];
  } else {
    markers = programMarkers.filter(((marker) => marker < TIMESHIFTING_AUTO_DURATION));
  }
  return markers;
};
